import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CreateService } from '../services/create.service';
import { LocalStorageService } from 'ngx-webstorage';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-home-layout',
    templateUrl: './home-layout.component.html',
    styles: []
})
export class HomeLayoutComponent {

    memberEmailId = this.storage.retrieve("userEmailId");

    isMemberExist: boolean = false;
    hasUserAccess: boolean = false;
    constructor(public router: Router, private createService: CreateService,
        private storage: LocalStorageService) {
    }

    //this.createService.SetIsMemberExist

    ngOnInit(): void {

        this.isGroupMemberExist(this.memberEmailId);
        this.checkUserAccess(this.memberEmailId);
    }

    public routeTo(url: any) {
        this.router.navigate(['/' + url])
    }

    goToHelp() {
        window.open(environment.helpUrl, "_blank");
    }

    isGroupMemberExist(membersEmail: any){
        this.createService.isGroupMemberExist(membersEmail).subscribe({
            next:(isMember: any) => {
            this.isMemberExist = isMember;
            }
        })
    
    }

    checkUserAccess(membersEmail: any){
        this.createService.checkUserAccessForUploadTemplate(membersEmail).subscribe({
            next:(isMember: any) => {
            this.hasUserAccess = isMember;
            }
        })
    
    }
}